import { DataQueryPaging } from '../DataQuery';
import { GridPaging } from '../DataState';

/**
 * Мапер для пагинации
 */
export class PagingMapper {
  /**
   * Отображает данные пагинации грида в объект запроса
   * @param src - состояние UI
   */
  mapToQuery(src: GridPaging): DataQueryPaging {
    return {
      count: true,
      skip: src.pageIndex * src.pageSize,
      top: src.pageSize,
      pageIndex: src.pageIndex,
    };
  }
}
